import { InquiryForm } from '../components/InquiryForm';
import { SiteFooter, SiteHeader } from '../components/Chrome';

export function StartPage() {
  return (
    <>
      <SiteHeader />
      <main>
        <section className="site-wrap start-hero">
          <div className="start-copy">
            <div className="overline">Start with the problem</div>
            <h1>What is slowing your business down?</h1>
            <p className="hero-sub">Tell me what is happening in your own words. You do not need to know what kind of technology it involves or what the solution should be.</p>
            <ul className="start-reassurance">
              <li><span aria-hidden="true">✓</span><span>A real person reads it</span></li>
              <li><span aria-hidden="true">✓</span><span>No obligation to proceed</span></li>
              <li><span aria-hidden="true">✓</span><span>Your details are used to respond to this enquiry</span></li>
            </ul>
          </div>
          <InquiryForm compact />
        </section>
      </main>
      <SiteFooter />
    </>
  );
}
